<script setup lang="ts">
import { ref } from "vue"

const props = defineProps(["text", "bgColors", "value", "isDeletable"]);
const emits = defineEmits(["status-clicked", "delete-clicked"])

const isDeleteButtonShown = ref(false)

const onStatusClicked = (value) => {
    console.log("status-clicked", value)
    emits("status-clicked", value)
}

const onDeleteClicked = (value) => {
    emits("delete-clicked", value)
}

</script>

<template>
    <div @dblclick="isDeleteButtonShown = !isDeleteButtonShown" @click="onStatusClicked(value)" :style="{ 'backgroundColor': bgColors[value]}" class="chip-container whitespace-nowrap relative">
        <p>{{ props.text }}</p>
        <button v-if="isDeletable && isDeleteButtonShown" @click="onDeleteClicked(value)" class="delete-button">
            x
        </button>
    </div>
</template>
  
<style scoped>


.chip-container {
    position: relative  ;
    border-radius: .6rem;
    color: white;
    font-size: 1.3rem;
    font-weight: 400;
    padding: 0.5rem 3rem;
    display: inline-flex;
    justify-content: center;
    text-align: center;
    user-select: none;
  }

  .chip-list > .chip-container{
    display: inline-block;
  }
  


.delete-button {
    position: absolute;
    left: -7px;
    top: -7px;
    border-radius: 50%;
    background-color: #a2a2a274;
    height: 2rem;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    color: #ffffff;
}

.delete-button:hover {
    background-color: #a2a2a2;
}
</style>